import { Flex, Box, Spacer, Stack, Checkbox } from '@chakra-ui/react'
import { FC } from 'react'

import useAlertPurchase from '@hook/alerts/use-alert-purchase'

import ModalComment from './ModalComment'

// status (mesmos códigos de handleCheck) -> label/cor do checkbox
const STATUS_OPTIONS = [
  { status: 0, label: 'Iniciado', colorScheme: 'yellow' },
  { status: 1, label: 'Processamento', colorScheme: 'orange' },
  { status: 2, label: 'Concluídos', colorScheme: 'green' },
  { status: 3, label: 'Erros', colorScheme: 'red' },
  { status: 4, label: 'Aguardando Aprovação', colorScheme: 'yellow' },
  { status: 5, label: 'Recusado', colorScheme: 'red' }
]

const BarToggleProcess: FC = () => {
  const {
    selecteds,
    handleCheck,
    iniciadoCheck,
    atencaoCheck,
    noprazoCheck,
    atrasadoCheck,
    aguardandoAprovacaoCheck,
    recusadoCheck
  } = useAlertPurchase()

  // Checkboxes controlados pelo estado do contexto (não se dessincronizam ao remontar)
  const checks: Record<number, boolean> = {
    0: iniciadoCheck,
    1: atencaoCheck,
    2: noprazoCheck,
    3: atrasadoCheck,
    4: aguardandoAprovacaoCheck,
    5: recusadoCheck
  }

  return (
    <Flex
      height="58px"
      paddingX={4}
      borderBottom="solid 1px"
      borderColor="gray.200"
      alignItems="center"
    >
      <Box>{selecteds.length > 0 ? <ModalComment /> : <></>}</Box>

      <Spacer />

      <Box>
        <Stack spacing={[1, 5]} direction={['column', 'row']}>
          {STATUS_OPTIONS.map(option => (
            <Checkbox
              key={option.status}
              size="md"
              borderColor="black"
              colorScheme={option.colorScheme}
              isChecked={checks[option.status]}
              onChange={e => {
                handleCheck(e.target.checked, option.status)
              }}
            >
              {option.label}
            </Checkbox>
          ))}
        </Stack>
      </Box>
    </Flex>
  )
}

export default BarToggleProcess
